module.exports = __webpack_public_path__ + "static/media/HP-LoginImage-@2x.60e02bc5.png";